import React from 'react';

const LawyerServiceCard = ({ service }) => {
    return (
        <article className="lawyer_services-card">
            <img src={service.url} alt="" className="lawyer_services-card-svg" />
            <h4 className="lawyer_services-card-data">{service.title}</h4>
        </article>
    );
}

export default LawyerServiceCard;
